import { IntercomAPI } from 'modules/intercom';

import { useIsSupportLayerEnabled } from './useIsSupportLayerEnabled';
import { useRedirectToSupportPage } from './useRedirectToSupportPage';

export const useHandleSupport = ({ onSupportLayerEnabled }: { onSupportLayerEnabled?: () => void } = {}) => {
  const isSupportLayerEnabled = useIsSupportLayerEnabled();
  const redirectToSupportPage = useRedirectToSupportPage();

  return () => {
    if (!isSupportLayerEnabled) {
      IntercomAPI.show();
      return;
    }

    onSupportLayerEnabled?.();
    redirectToSupportPage();
  };
};
